// @owners { team: patient-health }
import { Row, SteppedProgressBar } from '@alto/design-system';
import { useNavigation } from '@alto/navigation';
import React from 'react';
import styledNative from 'styled-components/native';

export const FAMILY_MEMBER_ROUTES: Record<string, number> = {
  RouteAddFamilyMember: 0,
  RouteFamilyMemberMedicalInfo: 1,
  RouteFamilyMemberBenefits: 2,
};
const TOTAL_STEPS = 3;

const ProgressContainer = styledNative(Row)`
  width: 240px;
`;

export const FamilyMemberProgressBar = () => {
  const { getCurrentRouteName } = useNavigation();
  const routeName = getCurrentRouteName();
  if (!routeName) {
    return null;
  }

  const completedSteps = FAMILY_MEMBER_ROUTES[routeName] ?? 0;

  const showProgressBar = completedSteps !== 0;

  if (!showProgressBar) {
    return null;
  }

  return (
    <ProgressContainer>
      <SteppedProgressBar
        completedSteps={completedSteps}
        totalSteps={TOTAL_STEPS}
      />
    </ProgressContainer>
  );
};
